/// <amd-module name="Checks/ChecksOverview/ChecksActionsCreator" />

import { ChecksActions } from "Checks/ChecksOverview/ChecksActions";
import { ChecksSource } from "Checks/ChecksOverview/ChecksSource";
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IUpdateCheckPayload {
    check: PipelineChecksContracts.CheckConfiguration;
    checkAssignmentId: number;
}


export class ChecksActionsCreator {

    public constructor(pageContext: IVssPageContext) {
        this._actions = ChecksActions.getInstance();
        this._source = ChecksSource.getInstance(pageContext);
    }

    public updateCheck(check: PipelineChecksContracts.CheckConfiguration, checkDefinitionRefId: string): Promise<void> {
        return this._source.updateCheck(check).then((updatedCheck) => {
            let checkConfigurationData = {
                definitionRefId: checkDefinitionRefId,
                checkConfiguration: updatedCheck
            } as PipelineChecksContracts.CheckConfigurationData;

            this._actions.updateCheck.invoke(checkConfigurationData);
            return Promise.resolve();
        }, (error) => {
            return Promise.reject(error);
        });
    }

    public addCheck(check: PipelineChecksContracts.CheckConfiguration, checkDefinitionRefId: string): Promise<void> {
        return this._source.addCheck(check).then((addedCheck) => {
            let checkConfigurationData = {
                definitionRefId: checkDefinitionRefId,
                checkConfiguration: addedCheck
            } as PipelineChecksContracts.CheckConfigurationData;
            
            this._actions.addCheck.invoke(checkConfigurationData);
            return Promise.resolve();
        }, (error) => {
            return Promise.reject(error);
        });
    }

    public deleteCheck(checksAssignmentId: number): Promise<void> {
        return this._source.deleteCheck(checksAssignmentId).then(() => {
            this._actions.deleteCheck.invoke(checksAssignmentId);
            return Promise.resolve();
        }, (error) => {
            return Promise.reject(error);
        });
    }

    public filterChecks(searchText: string): void {
        this._actions.filterChecks.invoke(searchText);
    }

    private _actions: ChecksActions;
    private _source: ChecksSource;
}
